var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKmComoros(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20161)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H-7.57031V11.25H60V0Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 11.25H-7.57031V22.5H60V11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 22.5H-7.57031V33.75H60V22.5Z",
    fill: "#BE0027"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 33.75H-7.57031V45H60V33.75Z",
    fill: "#3B5AA3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0V45L26.4346 22.5615L60 0Z",
    fill: "#239E46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1835 12.4278C53.6543 12.0498 57.0732 18.0088 57.0644 22.6143C57.082 28.0635 51.914 32.5459 47.1503 32.2822C49.7168 31.0694 52.8632 27.6504 52.8808 22.5879C52.9072 18.0088 50.288 14.0186 46.1748 12.4278H46.1835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2891 17.3145L47.3438 16.4971L48.627 16.9014L48.1699 15.6357L48.9434 14.5459L47.6074 14.5986L46.8164 13.5176L46.4385 14.8096L45.1729 15.2314L46.2803 15.9785L46.2891 17.3145ZM46.3154 21.8936L47.3701 21.0674L48.6533 21.4717L48.1875 20.2148L48.9697 19.125L47.625 19.1689L46.834 18.0967L46.4648 19.3799L45.1904 19.8105L46.3066 20.5576L46.3154 21.8936ZM46.2979 26.5166L47.3525 25.6904L48.627 26.0947L48.1699 24.8379L48.9434 23.748L47.6074 23.792L46.8164 22.7197L46.4385 24.0029L45.1729 24.4248L46.2803 25.1807L46.2979 26.5166ZM46.3154 31.1748L47.3701 30.3574L48.6621 30.7617L48.1963 29.4961L48.9785 28.4063L47.6338 28.459L46.8428 27.3779L46.4736 28.6699L45.1992 29.0918L46.3154 29.8389V31.1748Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmComoros);
export default __webpack_public_path__ + "static/media/km Comoros.74b81c0fe99c4dc0c66633bf344c6e0f.svg";
export { ForwardRef as ReactComponent };